import { pdf } from '@react-pdf/renderer';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import moment from "moment";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { ImprimirCodigo } from "../imprimir/ImprimirCodigo";
import ReporteProducto from './ReporteProducto';
import { ImprimirProducto } from "./ImprimirProducto";

const TablaEditarProductos = ({ datos, setProductoEditarImagenes }) => {
  const { token } = useContextUsuario();
  const { setListaProductos, ActualizarLista } = useContextEmpleado();
  const tableRef = useRef();
  const tableInstance = useRef(null);
  const navigate = useNavigate();

  const handleGenerarReportePDF = async (producto) => {
    Swal.fire({
      title: 'Generando Reporte...',
      text: 'Preparando ficha técnica del producto',
      allowOutsideClick: false,
      didOpen: () => { Swal.showLoading(); }
    });

    try {
      // Lógica de generación vista en HomeEditarVenta.jsx
      const blob = await pdf(<ReporteProducto producto={producto} />).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Reporte_${producto.codigo}_${moment().format('YYYYMMDD')}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error(error);
      mostraAlertaError("No se pudo generar el reporte PDF.");
    }
  };

  const handleImprimir = (producto) => {
    ImprimirProducto(producto);
  };

  const handleEditarProducto = useCallback((rowData) => {
    navigate(`/app/admin/productos/gestionar/${rowData.id}`, {
      state: { datos: rowData }
    });
  }, [navigate]);

  useEffect(() => {
    if (datos.length > 0) {
      const requiredFields = ['id', 'nombre', 'codigo', 'descripcion', 'precio', 'costo', 'existencia', 'impuesto', 'estado'];
      const missingFields = requiredFields.filter(field => !datos[0].hasOwnProperty(field));
      if (missingFields.length > 0) {
        console.error(`Los datos no contienen las propiedades necesarias: ${missingFields.join(', ')}`);
        return;
      }
    }

    if (!tableInstance.current) {
      tableInstance.current = $(tableRef.current).DataTable({
        data: datos,
        columns: [
          {
            targets: 0,
            title: "Producto",
            data: null,
            render: (data, type, rowData) => {
              return `
                <div>
                  <strong class="text-wrap">${rowData.nombre}</strong><br />
                  <small class="text-muted">Código: ${rowData.codigo || ""}</small>
                  <br />
                  <small class="text-muted text-truncate" style="max-width: 200px; display: inline-block;" title="${rowData.descripcion || ""}">
                    ${rowData.descripcion || ""}
                  </small>
                </div>
                <div style="display: flex; justify-content: flex-start; gap: 0.5em; flex-wrap: wrap; margin-top: 0.5em;">
                  <button class="btn btn-outline-primary btn-sm editar-btn" title="Editar Producto" style="min-width: 35px;" data-id="${rowData.id}">
                    <i class="fas fa-pen"></i>
                  </button>
                  <button class="btn btn-outline-danger btn-sm eliminar-btn" title="Eliminar Producto" style="min-width: 35px;" data-id="${rowData.id}">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                  <button class="btn btn-outline-info btn-sm imprimir-btn" title="Imprimir Código" style="min-width: 35px;" data-id="${rowData.id}">
                    <i class="fas fa-print"></i>
                  </button>
                  <button class="btn btn-outline-success btn-sm reporte-btn" title="Ver Reporte PDF" style="min-width: 35px;" data-id="${rowData.id}">
                    <i class="fas fa-file-pdf"></i>
                  </button>
                </div>
              `;
            },
          },
          { targets: 1, title: "Precio", data: "precio", render: (data, type, row) => formatoMoneda(row.precio) },
          { targets: 2, title: "Costo", data: "costo", render: (data, type, row) => formatoMoneda(row.costo) },
          { targets: 3, title: "Existencia", data: "existencia" },
          {
            targets: 4,
            title: "Vendido",
            data: null,
            render: (data, type, row) => {
              const totalVendido = row.lotes?.reduce((total, lote) => {
                return total + Number(lote.vendido || 0);
              }, 0) || 0;

              return totalVendido;
            },
          },
          {
            targets: 5,
            title: "Anulado",
            data: null,
            render: (data, type, row) => {
              const totalAnulado = row.lotes?.reduce((total, lote) => {
                return total + Number(lote.anulado || 0);
              }, 0) || 0;

              return totalAnulado;
            },
          },
          {
            targets: 6,
            title: "Estado",
            data: "estado",
            render: (data, type, row, meta) => {
              return `<span class="badge ${data === "Disponible" ? "badge-success" : "badge-danger"
                }">${data}</span>`;
            },
          },
        ],
        paging: true,
        lengthChange: true,
        ordering: true,
        info: true,
        autoWidth: true,
        responsive: true,
        dom:
          "<'row mb-3'<'col-sm-12 col-md-6 text-left'l><'col-sm-12 col-md-6 text-right'f>>" +
          "<'row'<'col-sm-12'tr>>" +
          "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
        language: {
          decimal: "",
          emptyTable: "No hay información",
          info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
          infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
          infoFiltered: "(Filtrado de _MAX_ total entradas)",
          infoPostFix: "",
          thousands: ",",
          lengthMenu: "Mostrar _MENU_ Entradas",
          loadingRecords: "Cargando...",
          processing: "Procesando...",
          search: "Buscar:",
          zeroRecords: "Sin resultados encontrados",
          paginate: {
            first: "|<<",
            last: ">>|",
            next: ">>",
            previous: "<<",
          },
        },
        lengthMenu: [
          [5, 10, 25, 50, -1],
          [5, 10, 25, 50, "Todos"]
        ],
        stateSave: true,
        destroy: true,
      });

      const handleButtonClick = (e) => {
        const target = $(e.target).closest('button');
        if (!target.length) return;
        const rowData = tableInstance.current.row(target.closest('tr')).data();

        if (target.hasClass('editar-btn')) {
          handleEditarProducto(rowData);
        } else if (target.hasClass('eliminar-btn')) {
        } else if (target.hasClass('imprimir-btn')) {
          ImprimirProducto(rowData);
        } else if (target.hasClass('reporte-btn')) {
          handleGenerarReportePDF(rowData);
        }

      };

      $(tableRef.current).on("click", "button", handleButtonClick);

      return () => {
        $(tableRef.current).off("click", "button", handleButtonClick);
        if (tableInstance.current) {
          tableInstance.current.destroy();
          tableInstance.current = null;
        }
      };
    } else {
      // Actualiza los datos sin destruir la instancia de la tabla
      tableInstance.current.clear().rows.add(datos).draw();
    }
  }, [datos, handleEditarProducto, token, setListaProductos, ActualizarLista]);

  return (
    <div className="table-responsive">
      <table
        ref={tableRef}
        id="productos"
        className="table table-bordered table-hover nowrap"
        style={{ width: "100%" }}
      ></table>
    </div>
  );
};

export default TablaEditarProductos;